// extracted by mini-css-extract-plugin
module.exports = {"category":"X_dF","wrapp":"X_dG","category__wrapper":"X_dH"};